const menuItems = document.querySelectorAll(
    ".lux-header .lux-footer .lux-menu-link",
);

menuItems.forEach((menuItem) => {
    const thisHref = menuItem.getAttribute("href")?.split("?")[0];

    if (thisHref !== location.pathname) return;

    menuItem.classList.add("active");

    if (!menuItem.closest(".lux-main-menu-overlay")) return;

    const id = menuItem.closest(".lux-section-menu")?.getAttribute("data-id");

    menuItem.closest(".lux-category-menu")?.classList.add("active");

    document
        .querySelector(`.lux-main-menu .lux-menu-link[data-id=${id}]`)
        ?.classList.add("active");
});
